import type { CSSProperties } from 'react'
import { createTheme } from '@mui/material/styles'
import { BRANDING } from './config/branding'

// Wave-4 §2 (D3): custom data-display variants. Roboto ships 400/500/700 only
// (no 600 — a 600 silently renders 700), so weights here are the HONEST loaded ones.
declare module '@mui/material/styles' {
  interface TypographyVariants {
    eyebrow: CSSProperties
    dataValue: CSSProperties
    dataValueLg: CSSProperties
  }
  interface TypographyVariantsOptions {
    eyebrow?: CSSProperties
    dataValue?: CSSProperties
    dataValueLg?: CSSProperties
  }
}
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    eyebrow: true
    dataValue: true
    dataValueLg: true
  }
}

/** [round-3 port] vodafone freeze keeps gray-primary/brand-secondary; master's spec-§5 brand-primary
 *  swap deliberately NOT carried (port decision 2026-08-03, JL to revisit). Typography variants
 *  below are the carried surface. */
export function buildTheme(brandColor: string = BRANDING.defaultBrandColor) {
  return createTheme({
    palette: {
      primary: { main: '#374151' },
      secondary: { main: brandColor },
      background: { default: '#fafafa' },
    },
    typography: {
      fontFamily: 'Roboto, Arial, sans-serif',
      // Wave-4 §2: kicker/section label — smaller+heavier+tighter than stock overline.
      eyebrow: {
        fontSize: '10.5px',
        fontWeight: 500,
        letterSpacing: '0.1em',
        lineHeight: 1.6,
        textTransform: 'uppercase',
      },
      // Wave-4 §2: stat values in columns/rows — tabular so live repaints don't jitter.
      dataValue: {
        fontSize: '15px',
        fontWeight: 700,
        lineHeight: 1.4,
        fontVariantNumeric: 'tabular-nums',
      },
      // Wave-4 §2: hero number — PROPORTIONAL figures by design (dataviz: tabular at
      // display size sets every digit 0-wide and a "121" goes loose).
      dataValueLg: {
        fontSize: '48px',
        fontWeight: 700,
        letterSpacing: '-0.5px',
        lineHeight: 1.1,
      },
    },
    components: {
      MuiTypography: {
        defaultProps: {
          variantMapping: { eyebrow: 'div', dataValue: 'span', dataValueLg: 'div' },
        },
      },
    },
  })
}
